import React from "react"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {H3} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

import {SETTINGS_CUSTOMISE_BENEFITS_SETTINGS} from "../../../routes/routeConfig"

interface Props {
  onAdd: () => any
}

const NoCompanyBenefits: React.FC<Props> = (props) => {
  const {onAdd} = props
  return (
    <>
      <Flex alignItems="center" justifyContent="space-between" height="60px">
        <H3>
          <FormattedMessage id="admin.components.companyBenefitsList.minimalView.title" />
        </H3>
        <Flex>
          <ButtonRouterLink marginRight={1} primary id="settingsBenefitsSettingsId" to={SETTINGS_CUSTOMISE_BENEFITS_SETTINGS}>
            <FormattedMessage id="admin.companyBenefits.button.settings" />
          </ButtonRouterLink>
          <Button primary onClick={onAdd}>
            <FormattedMessage id="admin.components.companyBenefitsList.styledNameCountAndButton.buttonText" />
          </Button>
        </Flex>
      </Flex>
      <Flex marginTop={2} marginBottom={1}>
        <FormattedMessage id="admin.components.companyBenefitsList.emptyText" />
      </Flex>
      <Flex marginBottom={2}>
        <FormattedMessage id="admin.components.companyBenefits.settings.value" />
      </Flex>
    </>
  )
}

export default NoCompanyBenefits
